import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import MultiRangeFilter from '../../../../../molecules/formMultiRange';
import { CONNECTIONS_RANGE_MAX } from '../../../defaultFilters';
import { useConnectionsFilter } from './useConnectionsFilter';

export const ConnectionsFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit } = useConnectionsFilter({ setFilters });

  const initialValue = value
    ? {
        min: value.connections_count_gteq ?? 0,
        max: value.connections_count_lteq ?? CONNECTIONS_RANGE_MAX,
      }
    : null;

  return (
    <Formik
      initialValues={{ connections: initialValue }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="connections"
          title="Connections"
          min={0}
          max={CONNECTIONS_RANGE_MAX}
          component={MultiRangeFilter}
        />
      </Form>
    </Formik>
  );
};

ConnectionsFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

ConnectionsFilter.defaultProps = {
  value: null,
};
